var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionIconRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 7.8268C9.83333 7.90378 9.83333 8.09623 9.7 8.17321L7.3 9.55885C7.16667 9.63583 7 9.5396 7 9.38564L7 6.61436C7 6.4604 7.16667 6.36417 7.3 6.44115L9.7 7.8268Z",
    fill: "#C1C7D4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.0004,
    cy: 8.00015,
    r: 6.04224,
    stroke: "#C1C7D4",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionIconRound);
export default __webpack_public_path__ + "static/media/versionIconRound.c820fb1a3d74ff8c461da33190f8c90c.svg";
export { ForwardRef as ReactComponent };